/**
 * Dashboard quick path into exam simulation with the same query params as Quick Start.
 *
 * @module useQuickExamStartHref
 */

import { ROUTES } from '@/lib/routeConstants';
import { useSimulationResults } from '@/hooks/useSimulationResults';

const FALLBACK_EXAM_TYPE = 'goethe';
const FALLBACK_LEVEL = 'A1';

export interface QuickExamStartTarget {
  readonly href: string;
  readonly examType: string;
  readonly level: string;
}

/**
 * Same exam type, level, and `/exam?…` URL as the dashboard Quick Start card.
 */
export function useQuickExamStartHref(): QuickExamStartTarget {
  const { results } = useSimulationResults('all', 'all');
  const lastResult = results[0];
  const examType = lastResult?.examType ?? FALLBACK_EXAM_TYPE;
  const level = lastResult?.level ?? FALLBACK_LEVEL;
  const href = `${ROUTES.EXAM}?examType=${examType}&level=${level}`;
  return { href, examType, level };
}
